import React from "react";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";

const headerStyle = {
  color: "white",
  fontWeight: 600,
  fontSize: "14px",
  padding: "16px 20px",
  borderBottom: "2px solid #000080",
  position: "sticky",
  top: 0,
  zIndex: 2,
  backgroundColor: "#bb1ccc !important",
};

const cellStyle = {
  padding: "16px 20px",
  fontSize: "14px",
};

const DQRuleSuggestionsTable = ({
  suggestions = [],
  loading = false,
  emptyMessage = "No rule suggestions available for this asset.",
}) => (
  <TableContainer
    component={Paper}
    sx={{
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
      border: "1px solid #e0e0e0",
      borderRadius: "12px",
      maxHeight: "500px",
      overflow: "auto",
    }}
  >
    <Table sx={{ minWidth: 650 }} stickyHeader>
      <TableHead>
        <TableRow>
          <TableCell sx={headerStyle}>Column Name</TableCell>
          <TableCell sx={headerStyle}>Suggested Rule</TableCell>
          <TableCell sx={headerStyle}>Description</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {suggestions?.length ? (
          suggestions.map((rule, index) => (
            <TableRow
              key={`${rule.column_name}-${rule.rule_suggestions}-${index}`}
              sx={{
                backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                "&:hover": {
                  backgroundColor: "#f0f8ff",
                  transition: "background-color 0.2s ease",
                },
              }}
            >
              <TableCell
                sx={{
                  ...cellStyle,
                  fontWeight: 600,
                  color: "#2c3e50",
                }}
              >
                {rule.column_name}
              </TableCell>
              <TableCell
                sx={{
                  ...cellStyle,
                  fontSize: "14px",
                  color: "#555",
                  fontFamily: "monospace",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "4px",
                }}
              >
                {rule.rule_suggestions}
              </TableCell>
              <TableCell
                sx={{
                  ...cellStyle,
                  color: "#555",
                  maxWidth: "400px",
                  wordWrap: "break-word",
                }}
              >
                {rule.description || "N/A"}
              </TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell
              colSpan={3}
              align="center"
              sx={{
                padding: "40px 20px",
                fontSize: "16px",
                color: "#666",
                fontStyle: "italic",
              }}
            >
              {loading
                ? "Loading rule suggestions..."
                : emptyMessage}
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  </TableContainer>
);

export default DQRuleSuggestionsTable;


